import { useState } from "react";
import { View } from "react-native";
import web_save_tutorial from "src/assets/images/web_save_tutorial.png";
import Touchable from "src/components/Touchable";
import IconClipboard from "src/icons/IconClipboard";
import { Image, Text } from "src/swsh-native";

const SaveTutorialImage = ({
	saveText,
	onTextPress,
}: {
	saveText: string;
	onTextPress?: () => void;
}) => {
	const [height, setHeight] = useState(0);
	const width = height * (275 / 425);
	const [didLoad, setDidLoad] = useState(false);

	return (
		<View
			style={{
				flex: 1,
				width: "100%",
				alignItems: "center",
			}}
			onLayout={(event) => {
				setHeight(event.nativeEvent.layout.height);
			}}
		>
			{!!(width && height) && (
				<>
					<Image
						onLoad={() => {
							setDidLoad(true);
						}}
						alt="Tutorial on how to save an image"
						src={web_save_tutorial}
						dim={{
							height,
							width,
						}}
						style={{
							alignSelf: "center",
						}}
					/>
					{didLoad && (
						// Positioned to overlay on top of the "Save image" in the screenshot
						<Touchable
							animation="None"
							onPress={onTextPress}
							containerStyle={{
								position: "absolute",
								width: 1.05 * width,
								height: 0.12 * height,
								top: 0.55 * height,
								backgroundColor: "#2C2C2E",
								shadowColor: "#FFFFFF",
								shadowOpacity: 0.7,
								shadowRadius: 0.08 * width,
								borderWidth: 2,
								borderColor: "#FFFFFF4D",
								borderRadius: 0.04 * width,
							}}
							style={{
								flex: 1,
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "space-between",
								paddingHorizontal: 0.04 * width,
							}}
						>
							<Text
								semibold
								style={{
									fontSize: 0.04 * height,
								}}
							>
								{saveText}
							</Text>
							<IconClipboard size={0.055 * height} />
						</Touchable>
					)}
				</>
			)}
		</View>
	);
};
export default SaveTutorialImage;
